// /assets/uij-top-overlay-fix.js
// Fix voor Usercentrics cookie banner: nooit de layout "duwen" (CLS),
// maar altijd als overlay (fixed bottom). Ook body padding/margin resets
// die Usercentrics soms toevoegt om ruimte te reserveren.

(function () {
  const UC_SELECTORS = [
  "#usercentrics-root",
  "#usercentrics-cmp",
  ".uc-root",
  ".uc-overlay",
  ".uc-banner"
];


  function isVisible(el) {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function fixUsercentricsRoot(el) {
    if (!el || el.dataset.uijFixed === "1") return;

    // Alleen fixen als het echt een overlay/banner lijkt
    if (!isVisible(el)) return;

    el.dataset.uijFixed = "1";

    // Zorg dat de container zelf nooit in flow ruimte claimt
    el.style.position = "fixed";
    el.style.left = "0";
    el.style.right = "0";
    el.style.bottom = "0";
    el.style.top = "auto";
    el.style.width = "100%";
    el.style.zIndex = "2147483647";
    el.style.margin = "0";
    el.style.transform = "translateZ(0)";

    document.documentElement.classList.add("uij-has-cookie-overlay");
  }

  function resetBodyPushSpace() {
    // Usercentrics zet soms padding/margin op body/html om ruimte te reserveren.
    // Dat veroorzaakt CLS. We halen die "push space" weg.
    const body = document.body;
    const html = document.documentElement;
    if (!body) return;

    // Alleen aanpassen als er daadwerkelijk een UC overlay is gevonden
    if (!html.classList.contains("uij-has-cookie-overlay")) return;

    // Reset alleen de properties die voor "duwen" zorgen
    body.style.paddingTop = "";
    body.style.marginTop = "";
    body.style.paddingBottom = "";
    body.style.marginBottom = "";

    html.style.paddingTop = "";
    html.style.marginTop = "";
    html.style.paddingBottom = "";
    html.style.marginBottom = "";
  }

  function scanAndFix() {
    // Zoek Usercentrics containers en fix ze
    for (const sel of UC_SELECTORS) {
      document.querySelectorAll(sel).forEach((el) => {
        // Fix root/cmp containers (die zijn meestal de outer wrapper)
        if (el.id === "usercentrics-root" || el.id === "usercentrics-cmp" || String(el.className).includes("uc-")) {
          fixUsercentricsRoot(el);
        }
      });
    }

    // Als UC overlay aanwezig is: verwijder push-space
    resetBodyPushSpace();
  }

  // Run ASAP na DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scanAndFix, { once: true });
  } else {
    scanAndFix();
  }

  // Veel consent banners worden laat geïnjecteerd → observer
  const mo = new MutationObserver(() => scanAndFix());
  mo.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["style", "class"]
  });

  // Stop observer na 6s (performance)
setTimeout(() => mo.disconnect(), 6000);
})();
